import { useEffect, useRef } from "react";
import { Box, Button } from "@mui/material";
import LeftIcon from "@mui/icons-material/ChevronLeftRounded";

import { useTranslation } from "utils/locales/utilityFunctions";

import { styles } from "../styles";
import { AIEmptyState } from "./aiEmptyState";
import { MessageList } from "./messageList";
import { AiChatMessage } from "types/auth";
import { getInternalAppType } from "utils/brandingUtils";

type AIChatContentProps = {
  messages: AiChatMessage[];
  onSendMessage: (message: string) => void;
  onReset: () => void;
};

const suggestions = [
  "ai-chat-suggestion-create-project",
  "ai-chat-suggestion-basel-area",
  "ai-chat-suggestion-share-map",
  "ai-chat-suggestion-thinning",
];

const suggestionsGeorge = [
  "ai-chat-suggestion-observations",
  "ai-chat-suggestion-field-documentation",
  "ai-chat-suggestion-protected-nature",
  "ai-chat-suggestion-layers-and-data",
];

export function AIChatContent({ messages, onSendMessage, onReset }: AIChatContentProps) {
  const { translate } = useTranslation();
  const internalAppType = getInternalAppType({
    pathOrHost: window.location.hostname,
  });

  const bottomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const showReset = messages.length > 4;

  return (
    <Box sx={styles.content}>
      {messages.length === 0 ? (
        <AIEmptyState
          onSendMessage={onSendMessage}
          suggestions={internalAppType === "george" ? suggestionsGeorge : suggestions}
        />
      ) : (
        <>
          <Box sx={styles.navigateBackContainer}>
            <Button
              variant="text"
              size="small"
              onClick={onReset}
              startIcon={<LeftIcon />}
              color="secondary"
              sx={{
                px: 1,
                textTransform: "none",
                opacity: 0.8,
                "&:hover": {
                  opacity: 1,
                },
              }}
            >
              {translate("ai-chat-reset")}
            </Button>
          </Box>
          <MessageList messages={messages} />

          {showReset && (
            <Box sx={styles.resetContainer}>
              <Button
                variant="text"
                size="small"
                onClick={onReset}
                startIcon={<LeftIcon />}
                color="secondary"
                sx={{
                  px: 1,
                  textTransform: "none",
                  opacity: 0.8,
                  "&:hover": {
                    opacity: 1,
                  },
                }}
              >
                {translate("ai-chat-reset")}
              </Button>
            </Box>
          )}

          <div ref={bottomRef} />
        </>
      )}
    </Box>
  );
}
